import RoutesMap from 'route_control/RouteControl'
import { TicketList, TicketDetails,MyTicketDashboard, FindServiceList, FindServiceDetails, IncidentReports, TechnicalTickets, AdminTicket, TechnicalTicketHistory, TechnicalTicketDetails } from 'pages/help_desk'

const HelpDeskRoute = () => {
    return [
        {
            path: RoutesMap.TICKET_LIST.path,
            element: <TicketList />,
        },
        {
            path: RoutesMap.TICKET_DASHBOARD.path,
            element: <MyTicketDashboard />,
        },
        {
            path: RoutesMap.TICKET_DETAILS.path,
            element: <TicketDetails />,
        },
        {
            path: RoutesMap.FIND_SERVICE_LIST.path,
            element: <FindServiceList />,
        },
        {
            path: RoutesMap.FIND_SERVICE_DETAILS.path,
            element: <FindServiceDetails />,
        },
        {
            path: RoutesMap.INCIDENT_REPORTS.path,
            element: <IncidentReports />,
        },
        {
            path: RoutesMap.TECHNICAL_TICKETS.path,
            element: <TechnicalTickets />,
        },
        {
            path: RoutesMap.ADMIN_TICKET.path,
            element: <AdminTicket />,
        },
        {
            path: RoutesMap.TECHNICAL_TICKET_HISTORY.path,
            element: <TechnicalTicketHistory />,
        },
        {
            path: RoutesMap.TECHNICAL_TICKET_DETAILS.path,
            element: <TechnicalTicketDetails />,
        },
    ]
}

export default HelpDeskRoute;